var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "white",
    stroke: "#EE4D2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8095 11.2592L13.3488 8.3516C12.9196 7.84445 12.1592 7.76379 11.6757 8.21948C9.7169 10.0657 9.06804 11.9158 9.29031 14.0706C9.60713 17.1421 15.9526 24.0023 18.7579 25.6256C20.7037 26.7516 23.3858 25.5587 25.2195 23.9642C25.6875 23.5572 25.6973 22.854 25.2967 22.3806L22.7962 19.426C22.3278 18.8726 21.4924 18.8512 20.9477 19.3297C19.9182 20.2342 19.1201 20.6082 18.3101 20.3856C16.9995 20.0256 14.1846 16.8362 14.1746 15.2702C14.1689 14.3617 14.7693 13.7144 15.6114 13.0439C16.1656 12.6027 16.2671 11.7999 15.8095 11.2592Z",
    fill: "#EE4D2D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4e88376f4c8860a95f6ee6b06539798b.svg";
export { ForwardRef as ReactComponent };